/* BioActive+ — Bundle Discover behaviour. Static asset; wires every .bbd root.
   Tab switching + "Add to bundle" (dispatches document 'bb:add') and reflects
   the builder's 'bb:state' { counts } (keyed by variant id). */
(function () {
  function setup(root) {
    if (root.dataset.bbInit) return;
    root.dataset.bbInit = '1';
    var addLabel = root.getAttribute('data-add-label') || 'Add to bundle';

    function activate(idx) {
      root.querySelectorAll('[data-pick]').forEach(function (c) {
        var on = c.getAttribute('data-pick') === idx;
        c.classList.toggle('on', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === idx);
      });
    }

    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-bb-add]');
      if (add) {
        e.preventDefault();
        e.stopPropagation();
        var id = parseInt(add.getAttribute('data-variant-id'), 10);
        if (!id) return;
        document.dispatchEvent(new CustomEvent('bb:add', { detail: { id: id, product: {
          id: id,
          short: add.getAttribute('data-short') || '',
          name: add.getAttribute('data-name') || '',
          benefit: add.getAttribute('data-benefit') || '',
          img: add.getAttribute('data-img') || ''
        } } }));
        return;
      }
      var pick = e.target.closest('[data-pick]');
      if (pick) activate(pick.getAttribute('data-pick'));
    });

    document.addEventListener('bb:state', function (e) {
      var counts = (e.detail && e.detail.counts) || {};
      root.querySelectorAll('[data-ct]').forEach(function (c) {
        var n = counts[c.getAttribute('data-ct')] || 0;
        c.textContent = n > 0 ? n : '';
        c.style.display = n > 0 ? 'flex' : 'none';
      });
      root.querySelectorAll('[data-add-btn]').forEach(function (b) {
        var n = counts[b.getAttribute('data-variant-id')] || 0;
        b.classList.toggle('added', n > 0);
        var lab = b.querySelector('[data-add-label]');
        if (lab) lab.textContent = n > 0 ? ('In bundle (' + n + ')') : addLabel;
      });
    });
  }

  function init() { document.querySelectorAll('.bbd').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
